import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export const CHECKOUT_URL = 'https://hospitality-english-ready.impultienda.ar/checkout';
type CtaButtonProps = {
  label?: string;
  href?: string;
  className?: string;
};
export function CtaButton({
  label = 'Get the Hotel Toolkit',
  href = CHECKOUT_URL,
  className = ''
}: CtaButtonProps) {
  const isInternal = href.startsWith('#');
  return <a href={href} target={isInternal ? undefined : '_blank'} rel={isInternal ? undefined : 'noopener noreferrer'} className={`group mt-2.5 inline-flex items-center justify-center gap-3 rounded-full bg-red-500 px-[35px] py-7 text-center text-sm font-extrabold uppercase leading-none text-white shadow-xl transition-[transform,background-color] duration-200 ease-out hover:-translate-y-0.5 hover:bg-red-600 focus:outline-none focus-visible:ring-4 focus-visible:ring-red-500/30 sm:text-base ${className}`} data-id="element-43" data-mp="qk21567vvkf0">
      <span className="-mr-[0.12em] tracking-[0.12em]" data-id="element-44" data-mp="15a9b0xjtrv43">{label}</span>
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-45" data-mp="35x5vhbjwwk0w" />
    </a>;
}